export const DEVELOPMENTAL_SCALE = {
  1: "Emerging",
  2: "Developing",
  3: "Growing",
  4: "Effective",
  5: "Accomplished",
} as const;

export type ScoreLevel = keyof typeof DEVELOPMENTAL_SCALE;

export const BAND_TO_SCORE: Record<string, ScoreLevel> = {
  emerging: 1,
  expected: 3,
  exceeding: 5,
};

export const SCORE_COLORS: Record<ScoreLevel, string> = {
  1: "text-red-500",
  2: "text-orange-500",
  3: "text-yellow-600",
  4: "text-lime-600",
  5: "text-green-600",
};

export const SCORE_BG_COLORS: Record<ScoreLevel, string> = {
  1: "bg-red-500",
  2: "bg-orange-500",
  3: "bg-yellow-500",
  4: "bg-lime-500",
  5: "bg-green-500",
};

export function getScoreLabel(score: number): string {
  if (score < 1) return "No data";
  if (score > 5) score = 5;
  return DEVELOPMENTAL_SCALE[score as ScoreLevel] || "No data";
}

export function getScoreColor(score: number): string {
  if (score < 1) return "text-muted-foreground";
  const level = Math.min(Math.max(Math.round(score), 1), 5) as ScoreLevel;
  return SCORE_COLORS[level];
}

export function getScoreBgColor(score: number): string {
  if (score < 1) return "bg-muted";
  const level = Math.min(Math.max(Math.round(score), 1), 5) as ScoreLevel;
  return SCORE_BG_COLORS[level];
}

export function percentageToScore(percentage: number): ScoreLevel {
  if (percentage >= 80) return 5;
  if (percentage >= 65) return 4;
  if (percentage >= 50) return 3;
  if (percentage >= 35) return 2;
  return 1;
}